import { NgxSpinnerModule } from 'ngx-spinner';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'angular-highcharts';
import { ProgressbarModule } from 'ngx-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServicesModule } from './../services/services.module';
import { RegularTablesComponent } from './tables/regular-tables/regular-tables.component';
import { ColumnChartComponent } from './charts/column-chart.component';
import { FlightProgressComponent } from './flight-progress/flight-progress.component';
import { ConfirmationPageSuccessComponent } from './confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from './confirmation-page-fail/confirmation-page-fail.component';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { BusyIndicatorComponent } from './busy-indicator/busy-indicator.component';
import { YourjssiteamComponent } from './yourjssiteam/yourjssiteam.component';
import { ModalComponent } from './modal/modal.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AskQuestionFormComponent } from './ask-question-form/ask-question-form.component';
import { ViewQuestionsComponent } from './view-questions/view-questions.component';
import { AccordionModule as BootstrapAccordionModule } from 'ngx-bootstrap';
import { BrowserSupportTableComponent } from './browser-support-table/browser-support-table.component';
import { JssiFooterComponent } from './jssi-footer/jssi-footer.component';
import { FooterComponent } from './alliance/footer/footer.component';
import { RegionComponent } from './alliance/region/region.component';
import { ReferralProgressComponent } from './alliance/referral-progress/referral-progress.component';
import { UICarouselModule } from './ui-carousel';
import {ProgressBarModule} from 'angular-progress-bar';
import { ConfirmationPageProgressComponent } from './confirmation-page-progress/confirmation-page-progress.component';
import { LeftNavbarComponent } from './left-navbar/left-navbar.component';
import { MyJssiCardComponent } from './myJssi-card/my-jssi-card.component';
import { PowerBireportComponent } from './power-bireport/power-bireport.component';


@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    ChartModule,
    ServicesModule,
    NgxSpinnerModule,
    ProgressbarModule.forRoot(),
    AngularFontAwesomeModule,
    ModalModule.forRoot(),
    UICarouselModule,
    ProgressBarModule,
    BootstrapAccordionModule.forRoot()
  ],
  declarations: [
    RegularTablesComponent,
    ColumnChartComponent,
    FlightProgressComponent,
    ConfirmationPageSuccessComponent,
    ConfirmationPageFailComponent,
    BusyIndicatorComponent,
    YourjssiteamComponent,
    ModalComponent,
    AskQuestionFormComponent,
    ViewQuestionsComponent,
    BrowserSupportTableComponent,
    JssiFooterComponent,
    FooterComponent,
    RegionComponent,
    ReferralProgressComponent,
    ConfirmationPageProgressComponent,
    LeftNavbarComponent,
    MyJssiCardComponent,
    PowerBireportComponent
  ],
  exports: [
    UICarouselModule,
    RegularTablesComponent,
    ColumnChartComponent,
    FlightProgressComponent,
    NgxSpinnerModule,
    BusyIndicatorComponent,
    ConfirmationPageSuccessComponent,
    ConfirmationPageFailComponent,
    YourjssiteamComponent,
    ModalComponent,
    AskQuestionFormComponent,
    ViewQuestionsComponent,
    BrowserSupportTableComponent,
    JssiFooterComponent,
    ConfirmationPageProgressComponent,
    LeftNavbarComponent,
    MyJssiCardComponent,
    PowerBireportComponent
  ]
})
export class SharedComponentsModule { }



// WEBPACK FOOTER //
// ./src/app/shared-components/shared-components.module.ts